import {invalidateQueries, q} from "../../state";
import {UpdateWatcherTrigger, WatcherPreferences} from "platformed-client/types";
import {platformedClient} from "..";

export async function get_(): Promise<WatcherPreferences> {
  return await platformedClient.internalRequest("get", `/region/{region}/api/watcher_preferences`, {});
}

export async function getAccount(): Promise<WatcherPreferences> {
  return await platformedClient.internalRequest("get", `/region/{region}/api/watcher_preferences/account`, {});
}

export async function updateUserPreference(update: UpdateWatcherTrigger) {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/watcher_preferences`, {
    body: update,
  });
  await invalidateQueries([q.userWatcherPreferences.filter()]);
  return res;
}

export async function updateAccountPreference(update: UpdateWatcherTrigger) {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/watcher_preferences/account`, {
    body: update,
  });
  await invalidateQueries([q.accountWatcherPreferences.filter(), q.userWatcherPreferences.filter()]);
  return res;
}
